import React, { FC, useState } from "react";

export enum AvailablePlatform {
  Pom = "Pom",
}

const STORAGE_KEY = "platform";
const STORAGE_POM = "pom";
const STORAGE: Storage = sessionStorage;

interface IPlatformContext {
  activePlatform: AvailablePlatform;
  setActivePlatform(newPlatform: AvailablePlatform): void;
}

interface IPlatformProps {
  children?: React.ReactNode;
}

const usePlatformProvider = (_props: IPlatformProps): IPlatformContext => {
  const [activePlatform, setActivePlatform] = useState<AvailablePlatform>(AvailablePlatform.Pom);

  const setPlatform = (newPlatform: AvailablePlatform) => {
    STORAGE.setItem(STORAGE_KEY, STORAGE_POM);
    setActivePlatform(newPlatform);
  };

  return {
    activePlatform,
    setActivePlatform: setPlatform,
  };
};

const PlatformContext = React.createContext<IPlatformContext>({} as IPlatformContext);

export const PlatformProvider: FC<IPlatformProps> = (props) => {
  const platform = usePlatformProvider(props);

  return <PlatformContext.Provider value={platform}>{props.children}</PlatformContext.Provider>;
};

export const usePlatformContext = () => React.useContext(PlatformContext);
